export const PREVIEW_TIFD_REPORT_REQUEST = 'tifd/preview-report-request';
export const PREVIEW_TIFD_REPORT_SUCCESS = 'tifd/preview-report-success';
export const PREVIEW_TIFD_REPORT_FAILURE = 'tifd/preview-report-failure';

export const FILL_TIFD_WORKBOOK_REQUEST = 'tifd/fill-workbook-request';
export const FILL_TIFD_WORKBOOK_SUCCESS = 'tifd/fill-workbook-success';
export const FILL_TIFD_WORKBOOK_FAILURE = 'tifd/fill-workbook-failure';

export const GET_TIFD_REPORT_REQUEST = 'tifd/get-report-request';
export const GET_TIFD_REPORT_FAILURE = 'tifd/get-report-failure';

export const CLEAR_TIFD_REPORT = 'tifd/clear-report';
